import React, { useState } from 'react';

function AccordionBusinessTable({data}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <tr>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left text-indigo-500 font-bold">{data.name}</div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left">{data.contactEmail}</div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left">{data.contactNumber}</div>
        </td>
        {/* <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="text-left text-emerald-500 font-medium">{data.cellNumber}</div>
        </td> */}
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
          <div className="flex items-center">
            <button
              className={`text-slate-400 hover:text-slate-500   ${open && 'rotate-180'}`}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              aria-controls={`description-${data.id}`}
            >
              <span className="sr-only">Menu</span>
              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                <path d="M16 20l-5.4-5.4 1.4-1.4 4 4 4-4 1.4 1.4z" />
              </svg>
            </button>
          </div>
        </td>
      </tr>
      {/*
      Example of content revealing when clicking the button on the right side:
      Note that you must set a "colSpan" attribute on the <td> element,
      and it should match the number of columns in your table
      */}
      <tr id={`description-${data.id}`} role="region" className={`${!open && 'hidden'}`}>
        <td colSpan="100%" className="px-2 first:pl-5 last:pr-5 py-3">
          <div className="bg-slate-50   p-3 -mt-3">
            <div className="text-sm mb-3">
              <div className="font-medium text-slate-800  mb-1">{data.descriptionTitle}</div>
              <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Business Name
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.name}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Industry
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.industry}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Contact Name
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.contactName}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Contact Email
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.contactEmail}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    Contact Number
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data.contactNumber}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                {/* Left */}
                                <div className="text-sm text-slate-800  font-medium">
                                    How much rent do they pay ($)?*
                                </div>
                                {/* Right */}
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">$ {data.rentAmount}</span>
                                </div>
                            </li>
                        </ul>
                    </section> 
            </div>
          </div>
        </td>
      </tr>
    </>
  );
}

export default AccordionBusinessTable;
